import React from "react";
import Container from "react-bootstrap/Container";
import BlueImage from "../../assets/images/blue.jpeg";
import AddBannerImage1 from "../../assets/images/Home Page/whatsapp3.jpg";
import AddBannerImage2 from "../../assets/images/Home Page/whatsapp2.jpg";
import AddBannerImage3 from "../../assets/images/Home Page/whatsapp1.jpg";

const AddBannerData = [
  {
    id: 1,
    img: AddBannerImage1,
    link: "#",
  },
  {
    id: 2,
    img: AddBannerImage2,
    link: "#",
  },
  {
    id: 3,
    img: AddBannerImage3,
    link: "#",
  },
];

function AdBanner() {
  return (
    <div className="container AdBanner">
      <div className="d-flex justify-content-center my-4 row">
        {AddBannerData.map((item, index) => {
          return (
            <div
              key={index}
              className=" col-lg-4 col-md-12 col-sm-12 col-xs-12 d-flex justify-content-center align-items-center mt-4"
            >
              <img
                src={item.img}
                alt="Maged Bannar"
                className="img-fluid"
                style={{ borderRadius: "10px" }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AdBanner;
